// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Country Picker css */
.Country_inputContainer__ZzWpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.89vh;
    width: 23.1vw;
    padding: 0.1vh 0.89vh;
    height: 5.8vh;
    font-size: 2.78vh;
    border-radius: 0.5vh;
    border: 1px solid #A6A6A6;
}
.Country_flagImg__Z3t1n {
    height: 3.5vh;
    width: 3.5vh;
    margin-right: 1vw;
}
.Country_countryTxt__Ubxvq {
    white-space: nowrap;
    overflow: hidden;
}

/* Country Options css */
.Country_optionsContainer__8YtMw {
    width: 24vw;
    height: 50vh;
    overflow-y: scroll;
    background: white;
}
.Country_countryRow__YVk6r {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5vh 1vh;
    cursor: pointer;
}
.Country_imageWrapper__SAtKJ { 
    width: 13%;
}
.Country_dialCodeContainer__2-ATB {
    width: 20%;
}
.Country_isoContainer__yGhea {
    width: 10%;
}
.Country_lableContainer__6eW3y {
    width: 56%;
}
.Country_imageStyle__5-VRK {
    width: 2vw;
    height: 2vw;
}
.Country_dialText__rT2E2 {
    font-size: 2vh;
}`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/CountryPicker/Country.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,cAAc;AAClB","sourcesContent":["/* Country Picker css */\r\n.inputContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    margin-bottom: 0.89vh;\r\n    width: 23.1vw;\r\n    padding: 0.1vh 0.89vh;\r\n    height: 5.8vh;\r\n    font-size: 2.78vh;\r\n    border-radius: 0.5vh;\r\n    border: 1px solid #A6A6A6;\r\n}\r\n.flagImg {\r\n    height: 3.5vh;\r\n    width: 3.5vh;\r\n    margin-right: 1vw;\r\n}\r\n.countryTxt {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Country Options css */\r\n.optionsContainer {\r\n    width: 24vw;\r\n    height: 50vh;\r\n    overflow-y: scroll;\r\n    background: white;\r\n}\r\n.countryRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    padding: 0.5vh 1vh;\r\n    cursor: pointer;\r\n}\r\n.imageWrapper { \r\n    width: 13%;\r\n}\r\n.dialCodeContainer {\r\n    width: 20%;\r\n}\r\n.isoContainer {\r\n    width: 10%;\r\n}\r\n.lableContainer {\r\n    width: 56%;\r\n}\r\n.imageStyle {\r\n    width: 2vw;\r\n    height: 2vw;\r\n}\r\n.dialText {\r\n    font-size: 2vh;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `Country_inputContainer__ZzWpi`,
	"flagImg": `Country_flagImg__Z3t1n`,
	"countryTxt": `Country_countryTxt__Ubxvq`,
	"optionsContainer": `Country_optionsContainer__8YtMw`,
	"countryRow": `Country_countryRow__YVk6r`,
	"imageWrapper": `Country_imageWrapper__SAtKJ`,
	"dialCodeContainer": `Country_dialCodeContainer__2-ATB`,
	"isoContainer": `Country_isoContainer__yGhea`,
	"lableContainer": `Country_lableContainer__6eW3y`,
	"imageStyle": `Country_imageStyle__5-VRK`,
	"dialText": `Country_dialText__rT2E2`
};
export default ___CSS_LOADER_EXPORT___;
